/** Типы weekly-calendar (read + мутации сетки переноса). */

export interface CalendarConfig {
  editFrom: string;
  editTo: string;
  stepMinutes: number;
  editWeekdays: number[];
  pxPerMinute: number;
  timezone?: string | null;
}

/** Как donor `ScheduleTrainingsPage`: пн–пт рабочие для сетки; сб–вс визуально «выключены». */
export const DEFAULT_CALENDAR_CONFIG: CalendarConfig = {
  editFrom: '08:00',
  editTo: '20:00',
  stepMinutes: 30,
  editWeekdays: [0, 1, 2, 3, 4],
  pxPerMinute: 1.5,
  timezone: 'Europe/Moscow',
};

export interface SlotItem {
  id: number;
  slot_date: string;
  start_time: string;
  end_time: string;
  service_id: number;
  service_name: string;
  service_color: string | null;
  service_type_color: string | null;
  service_type_name: string | null;
  service_type_slug: string | null;
  trainer_id: number | null;
  trainer_name: string | null;
  max_participants: number | null;
  places_left: number | null;
  is_available: boolean;
  /** Статус занятия; undefined трактуем как active. */
  status?: 'active' | 'cancelled';
  recurring_series_id: number | null;
  service_group_type: string | null;
  /** Зал */
  space_name?: string | null;
  /** Аренда на весь день */
  is_all_day?: boolean;
  /** Услуга типа «Аренда» */
  is_rental?: boolean;
  first_client_name?: string | null;
  additional_clients_count?: number;
}

export interface WorkhoursEntry {
  weekday: number;
  start_time: string;
  end_time: string;
  is_active: boolean;
}

export interface MinutesInterval {
  s: number;
  e: number;
}

export interface LayoutConfig {
  editFromM: number;
  editToM: number;
  stepMinutes: number;
  pxPerMinute: number;
  columnWidth: number;
}

export interface PositionedSlot {
  slot: SlotItem;
  x: number;
  y: number;
  width: number;
  height: number;
  lane: number;
  maxLanes: number;
  isBackground?: boolean;
}

export type DragMode = 'move' | 'resize-n' | 'resize-s';

export type DragPhase = 'idle' | 'pending' | 'dragging' | 'committing';

export interface DragPreviewData {
  slotDate: string;
  startTime: string;
  endTime: string;
  x: number;
  y: number;
  width: number;
  height: number;
  isValid: boolean;
}

export interface DragState {
  phase: DragPhase;
  mode: DragMode;
  slot: SlotItem;
  grabOffsetMinutes: number;
  preview: DragPreviewData | null;
}

export interface CalendarFilters {
  trainerIds: Set<string>;
  serviceTypeIds: Set<string>;
  serviceIds: Set<string>;
}

export const DEFAULT_FILTERS: CalendarFilters = {
  trainerIds: new Set(),
  serviceTypeIds: new Set(),
  serviceIds: new Set(),
};

export type CalendarView = 'week' | 'day' | 'table';

export interface DayColumn {
  key: string;
  trainerId: string;
  title: string;
  serviceNames: string[];
}

export interface ScheduleSlotCreateDraft {
  slotDate: string;
  startTime: string;
  endTime: string;
  trainerUserId?: string;
}
